import { render, staticRenderFns } from "./CustomerFilters.vue?vue&type=template&id=46f1b058"
import script from "./CustomerFilters.vue?vue&type=script&lang=js"
export * from "./CustomerFilters.vue?vue&type=script&lang=js"
import style0 from "./CustomerFilters.vue?vue&type=style&index=0&id=46f1b058&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports